import React from 'react';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Welcome to Little Lemon</h1>
          <h2>Chicago's Favorite Mediterranean Restaurant</h2>
          <p>Experience the authentic flavors of the Mediterranean with our family recipes</p>
          <button className="cta-button">Reserve a Table</button>
        </div>
      </section>

      {/* Special Features Section */}
      <section className="features-section">
        <h2>Why Choose Little Lemon?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">🍽️</span>
            <h3>Fresh Ingredients</h3>
            <p>We use only the freshest, locally sourced ingredients in our dishes</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">👨‍🍳</span>
            <h3>Expert Chefs</h3>
            <p>Our experienced chefs bring authentic Mediterranean flavors to your plate</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🌿</span>
            <h3>Healthy Options</h3>
            <p>Enjoy our wide selection of healthy and nutritious Mediterranean dishes</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🍷</span>
            <h3>Wine Selection</h3>
            <p>Perfect wine pairings to complement your dining experience</p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="about-content">
          <div className="about-text">
            <h2>Our Story</h2>
            <p>Little Lemon is a family-owned Mediterranean restaurant, focused on traditional recipes served with a modern twist. The chefs draw inspiration from Italian, Greek, and Turkish culture and have a menu of 12-15 items that they rotate seasonally.</p>
            <p>The restaurant has a rustic and relaxed atmosphere with moderate prices, making it a popular place for a meal any time of the day.</p>
          </div>
          <div className="about-image">
            {/* Add your restaurant image here */}
            <div className="image-placeholder">Restaurant Image</div>
          </div>
        </div>
      </section>

      {/* Special Offers Section */}
      <section className="offers-section">
        <h2>Special Offers</h2>
        <div className="offers-grid">
          <div className="offer-card">
            <h3>Lunch Special</h3>
            <p>2-course meal with wine pairing</p>
            <span className="price">$29.99</span>
            <button className="offer-button">Book Now</button>
          </div>
          <div className="offer-card">
            <h3>Family Feast</h3>
            <p>4-course meal for the whole family</p>
            <span className="price">$89.99</span>
            <button className="offer-button">Book Now</button>
          </div>
          <div className="offer-card">
            <h3>Date Night</h3>
            <p>3-course meal with champagne</p>
            <span className="price">$69.99</span>
            <button className="offer-button">Book Now</button>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="cta-section">
        <h2>Ready to Experience Little Lemon?</h2>
        <p>Book your table now and enjoy an unforgettable Mediterranean dining experience</p>
        <div className="cta-buttons">
          <button className="cta-button primary">Reserve a Table</button>
          <button className="cta-button secondary">View Menu</button>
        </div>
      </section>
    </div>
  );
};

export default HomePage;